export const NEW_ARRIVAL_CATEGORY_ID = process.env
  .NEXT_PUBLIC_NEW_ARRIVAL_CATEGORY_ID as string;
